import React from 'react'

function Process() {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={0.48}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.596 13.401L5.94 15.887A2.5 2.5 0 013.86 17H0v3h3.86a5.5 5.5 0 004.576-2.45l.963-1.445-1.803-2.704zm3.005-4.507l.963-1.445A5.5 5.5 0 0116.142 5H19v3h-2.86a2.5 2.5 0 00-2.08 1.114L12.405 11.6 10.6 8.894z"
          fill="#fff"
        />
        <path d="M19 10V3l5 3.5-5 3.5z" fill="#fff" />
        <path
          d="M0 6.5h3.86a4 4 0 013.328 1.781l5.625 8.438A4 4 0 0016.14 18.5H19"
          stroke="#fff"
          strokeWidth={3}
        />
        <path d="M19 15v7l5-3.5-5-3.5z" fill="#fff" />
      </g>
    </svg>
  )
}

export default React.memo(Process)
